<template>
  <div v-if="currentTache">
    <div class="row">
      <div class="col-md-6 col-lg-8">
        <BreadCrumd :title="'Tâches'" :description="'Aperçu d\'une tâche'" />
      </div>
      <div class="col-md-6 col-lg-4 mt-3">
        <div class="row" v-if="currentTache.mission">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">
                    Mission concernée
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Titre :</span
                    ><span>
                      <router-link
                        :to="{
                          name: 'crm_mission-show',
                          params: { id: currentTache.mission.id },
                        }"
                        class="mr-4"
                        title="Aperçu"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                        <u class="text-custom-primary">
                          {{ currentTache.mission.titre }}</u
                        >
                      </router-link>
                    </span>
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Période :</span
                    ><span
                      >{{ currentTache.mission.date_debut }} -
                      {{ currentTache.mission.date_fin }}</span
                    >
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between px-2">
                    <span>Statut :</span
                    ><span
                      ><i
                        :style="`color: ${currentTache.mission.statut_obj.couleur}`"
                        :class="icons.ICON_STATUT"
                        class="mr-1"
                      ></i>
                      {{ currentTache.mission.statut_obj.nom }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-flex justify-content-end">
      <div class="col-md-10 col-lg-8 mt-lg-4" v-if="currentTache.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-6 text-custom-primary d-flex justify-content-between pr-3"
                  >
                    <span>Référence :</span>
                    {{ currentTache.document.reference }}
                  </td>
                  <td class="col-6 d-flex justify-content-between px-3">
                    <span>Statut :</span>
                    <span
                      ><i
                        :style="`color: ${currentTache.statut_obj.couleur}`"
                        :class="icons.ICON_STATUT"
                      ></i>
                      {{ currentTache.statut_obj.nom }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4 mt-2"
          @click.prevent="
            $router
              .push({
                name: 'crm_mission-show-tache',
                params: { id: currentTache.mission.id },
              })
              .catch(() => {})
          "
        >
          Liste des tâches
        </button>
        <button
          v-if="currentTache.mission.statut <= constantMission.STATUT_EN_COURS"
          type="button"
          class="btn btn-custom-primary mr-4 mt-2"
          @click.prevent="
            $router
              .push({
                name: 'crm_tache-create',
                params: { id: currentTache.mission.id },
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle tâche
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mt-2"
          v-if="
            currentTache.statut === constantTache.STATUT_EN_ATTENTE &&
            currentTache.mission.statut <= constantMission.STATUT_EN_COURS
          "
          @click.prevent="
            $router
              .push({
                name: 'crm_tache-edit',
                params: { id: currentTache.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>

      <div
        class="col-md-12 d-flex align-items-center mt-md-2 mt-lg-0 col-lg-6"
        :class="{
          'justify-content-between':
            currentTache.statut === constantTache.STATUT_TERMINEE &&
            currentTache.est_note &&
            currentTache.mission.statut === constantMission.STATUT_EN_COURS,
          'justify-content-end':
            currentTache.mission.statut !== constantMission.STATUT_EN_COURS,
        }"
      >
        <b-button
          variant="warning"
          class="btn-icon mr-4 mt-2"
          v-if="
            currentTache.statut > constantTache.STATUT_EN_ATTENTE &&
            currentTache.mission.statut === constantMission.STATUT_EN_COURS
          "
          @click.prevent="reinitialiser()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_RESET"></i>
          </span>
          Mettre en attente
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mr-4 mt-2"
          v-if="
            currentTache.statut === constantTache.STATUT_EN_ATTENTE &&
            currentTache.mission.statut === constantMission.STATUT_EN_COURS
          "
          @click.prevent="commencer()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_START"></i>
          </span>
          Commencer
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mr-4 mt-2"
          v-if="
            currentTache.statut === constantTache.STATUT_EN_PAUSE &&
            currentTache.mission.statut === constantMission.STATUT_EN_COURS
          "
          @click.prevent="reprendre()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_START"></i>
          </span>
          Continuer
        </b-button>

        <b-button
          variant="warning"
          class="btn-icon mr-4 mt-2"
          v-if="
            currentTache.statut === constantTache.STATUT_EN_COURS &&
            currentTache.mission.statut === constantMission.STATUT_EN_COURS
          "
          @click.prevent="mettreEnPause()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_PAUSE"></i>
          </span>
          Mettre en pause
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mt-2"
          v-if="
            currentTache.statut === constantTache.STATUT_EN_COURS &&
            currentTache.mission.statut === constantMission.STATUT_EN_COURS
          "
          @click.prevent="terminer()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_FINISH"></i>
          </span>
          Terminer
        </b-button>
        <span
          v-if="
            currentTache.statut === constantTache.STATUT_TERMINEE &&
            currentTache.est_note
          "
          class="bg-white p-2 rounded"
        >
          <span class="font-size-17 text-custom-primary font-weight-bold mr-2"
            >Note:
          </span>
          <star-rating
            @rating-selected="rate($event)"
            :star-size="22"
            :show-rating="false"
            :read-only="
              currentTache.mission.statut !== constantMission.STATUT_EN_COURS
            "
            active-color="#ad932f"
            :inline="true"
            :clearable="true"
            v-model="rating"
            :rating="currentRating"
            :text-class="'text-center'"
          />
        </span>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'crm_tache-show',
                params: { id: currentTache.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-eye text-custom-primary font-size-17"></i>
              Tâche</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tache_show-document',
                params: {
                  documentUuid: currentTache.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tache_show-note',
                params: {
                  id: currentTache.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Notes</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tache_show-compte-rendu',
                params: {
                  id: currentTache.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Compte-rendus</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import URL from '@/http/crm/mission_tache/tache';
import icons from '@/icons/crm/mission_tache/tache';
import StarRating from 'vue-star-rating';
import constantTache from '@/constants/crm/mission/tache';
import constantMission from '@/constants/crm/mission/mission';

export default {
  components: {
    StarRating,
  },
  data() {
    return {
      title: 'Gestion des taches - Aperçu',
      icons,
      mission: null,
      rating: 0,
      currentRating: 0,
      constantTache,
      constantMission,
    };
  },
  computed: {
    ...mapGetters('tache', ['currentTache']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('tache', ['getTache']),
    init() {
      this.getTache(this.$route.params.id).then(() => {
        this.rating = this.currentRating = this.currentTache.note;
      });
    },
    commencer() {
      this.sendAction(URL.TACHE_START);
    },

    mettreEnPause() {
      this.sendAction(URL.TACHE_PAUSE);
    },
    reprendre() {
      this.sendAction(URL.TACHE_CONTINUE);
    },
    terminer() {
      this.sendAction(URL.TACHE_FINISH);
    },
    reinitialiser() {
      this.sendAction(URL.TACHE_RESET);
    },
    rate(event) {
      this.sendAction(
        URL.TACHE_RATE,
        'Voulez-vous vraiment donner cette note: ' + event + ' ?',
        { rating: this.rating }
      ).then((res) => {
        if (!res) {
          this.rating = this.currentRating;
        }
      });
    },

    sendAction(action, msg = null, data = {}) {
      return this.showConfirmValidation(msg)
        .then((result) => {
          if (result.value) {
            window.axios
              .post(URL.TACHE + '/' + this.currentTache.id + action, data)
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.init();
              })
              .catch(() => {});
          }
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
